import { string, bool, instanceOf } from 'prop-types'

import sendTrackingEvent from '../../../../utilities/sendTrackingEvent.js'
import keyPress from '../../../../utilities/keyPress.js'
import Icon from '../../../icon/index.js'
import Post from '../../../../../models/Post.js'

function getPostSocialCommerce(post) {
  if (!post || !post.socialCommerceEnabled || !post.socialCommerceUrl) {
    return {
      enabled: false,
    }
  }
  let link = post.socialCommerceUrl

  if (link.indexOf('http://') !== 0 && link.indexOf('https://') !== 0) {
    link = `http://${link}`
  }

  return {
    enabled: post.socialCommerceEnabled,
    link,
    label: post.socialCommerceLabel,
    tagline: post.socialCommerceTagline,
  }
}

export default function TileGridSocialCommerce({
  post,
  color,
  feedKey,
  allowCookies = true,
  enableWebAnalytics = false,
}) {
  const socialCommerce = getPostSocialCommerce(post)
  if (!socialCommerce.enabled) {
    return null
  }

  const handleClick = () => {
    sendTrackingEvent({
      action: 'click',
      allowCookies,
      enableWebAnalytics,
      ctaType: 'flow_cta',
      eventName: 'cta_clicked',
      eventLabel: 'cta',
      eventAction: 'clicked',
      interactive: true,
      flowKey: feedKey,
      postId: post.key,
      target: 'cta',
      postPosition: post.index,
    })
  }
  return (
    <div className="bzfy-c-tilegrid-post__minimalistic-overlay-commerce">
      <div
        onClick={handleClick}
        onKeyDown={(e) => keyPress(e, handleClick)}
        role="button"
        style={{ color }}
        tabIndex={0}
      >
        <span className="bzfy-c-tilegrid-post__minimalistic-overlay-commerce-text">
          {socialCommerce.label}
        </span>
        <span
          className="bzfy-c-tilegrid-post__minimalistic-overlay-commerce-icon"
          style={{ borderColor: color }}
        >
          <Icon color={color} icon="arrow-right" />
        </span>
      </div>
    </div>
  )
}

TileGridSocialCommerce.propTypes = {
  allowCookies: bool,
  color: string.isRequired,
  enableWebAnalytics: bool,
  feedKey: string.isRequired,
  post: instanceOf(Post).isRequired,
}
